import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import CusProgressBar from '../components/CusProgressBar';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import {FormTitle,CusFormComboBox, FormInput, FormSubTitle, CusFormLabel, CusFormInput, FormSubTitleTooltip, FormComboBox, FormCheckbox, CusFormInput2} from '../validation/Form-Components';
import {blockValidator, buildingValidator, emailValidator, levelValidator, postalCodeValidator, streetValidator, unitNoValidator,mobileNoValidator, reqDDLValidator} from '../validation/Validators';
import config from '../appconfig/config.json';
import service from '../services/ApiService';
import { useHistory } from "react-router-dom";
import SubHeader from '../components/SubHeader';
import CusFormCheckbox from '../components/CusFormCheckbox';
import appDetailsData from '../data/applicantdetailsdata.json';
import countryCodes from '../data/countrycode.json';
import Loading from '../components/Loading';
import CusRadioButton from '../components/CusRadioButton';
import genders from '../data/gender.json';
import racecodes from '../data/racecode.json';
import residentialcodes from '../data/residentialcode.json';
import nationalitycodes from '../data/nationality.json';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import helper from '../factory/Helper.js';
import { filterBy } from "@progress/kendo-data-query";
import positions from '../data/position.json';
import countries from '../data/domicilecountries.json';
import countriesriskdashboard from '../data/countrieswealth.json';
import ApplicantDtlsOccupation from '../components/ApplicantDtlsOccupation';
import occupations from '../data/industrylist.json';
import CusToast from '../components/CusToast';
import myInfoApiCountries from '../data/myInfoApiCountryList.json';
 

const ApplicantDetails = (props) => {
    
    let timer;
    const detailsType='3';
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 40 };
    const dobRegex = new RegExp(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);
   
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);
    const [nameCbo, setNameCbo] = useState({})
    const [selectedRdoValue, setSelectedRdoValue] = useState('Y'); //default to 'Y'
    const [selectedRdoPersWealthSGValue, setSelectedRdoPersWealthSGValue] = useState('Y'); 
    const [holders, setHolders]  = useState([]);
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [fCountries, setfCountries] = useState(countries.slice());  //filtered countries
    const [fCountriesRisk, setfCountriesRisk] = useState(countriesriskdashboard.slice());  //filtered countries

    const [persWealthCouOth, setPersWealthCouOth] = useState(false);

    const [occupList,setOccupList] = useState([]);

    const [applicantDetails, setApplicantDetails] = useState({
        myInfo:{
            HanyuName:"",
            AliasName:"",
            HanyuAliasName:"",
            MarriedName:"",
            IDNum:"",
            DOB:"",
            Gender:"",
            Race:"",
            Nationality:"",
            CnOfBirth:"",
            ResStatus:"",
            Designation:"",

            ResAddType:"",
            ResBlkNo:"",
            ResStreet:"",
            ResFlrNum:"",
            ResUnitNo:"",
            ResBldName:"",
            ResAddLine1:"",
            ResAddLine2:"",
            ResPostalCode:"",
            ResCountry:"",
        },

        titleCbo:"",
        marStatusCbo:"",
        counOfDomicileCbo:"",
        mno:"",
        em:"",

        MailAddType:config.addTypeLocal,
        MailBlkNo: "",
        MailStreet: "",
        MailFlrNum: "",
        MailUnitNo: "",
        MailBldName: "",
        MailPostalCode: "",
        MailCountry:appDetailsData.DefCountry.label,

        DescActOcc11:'',
        DescActOcc21:'',
        DescActOcc31:'',

        SG: false,
        BN: false,
        MY: false,
        CN: false,
        ID: false,
        IN: false,
        OTH: false,
        PersWealthOTH: ''
    });

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        appDetailsData.nameDDL.data = [];
        getData();

        return () => clearTimeout(timer);
    }, []);

    const getData = () => {

        service.get().then( res => {
            setIsLoading(false);
            if(res.data.isSucess) {
                createHolders(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
            
        })
        .catch(err=>{
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }


    const bindFormData = (resData) => {

        const data =resData.ApplicantDtls;
        const myInfoData = resData.ApplicantsDtlsMyInfo;
        let occupArray = [];
        try{
            const nameddlData = {"value":myInfoData.IDNum? myInfoData.IDNum : '', "label":myInfoData.Name? myInfoData.Name: ''};
 
            appDetailsData.nameDDL.data.push(nameddlData);
            setNameCbo(nameddlData);
            setSelectedRdoValue(data? data.MailAddrSameAsRes !== null? data.MailAddrSameAsRes:myInfoData.ResAddType === config.addTypeForeign? 'N':'Y':'Y');
            setSelectedRdoPersWealthSGValue(data? data.PersWealthSG !==null ? data.PersWealthSG:'Y':'Y');
            setPersWealthCouOth(data? data.PersWealthCou.OTH === 'true'? true:false:false);
            occupArray = setOccListArray(data);
            setOccupList(occupArray);
           
            setApplicantDetails({
                myInfo:{
                    HanyuName:myInfoData.HanyuName !==null? myInfoData.HanyuName:'',
                    AliasName:myInfoData.AliasName !==null? myInfoData.AliasName:'',
                    HanyuAliasName:myInfoData.HanyuAliasName !==null? myInfoData.HanyuAliasName:'',
                    MarriedName:myInfoData.MarriedName !==null? myInfoData.MarriedName:'',
                    IDNum:myInfoData.IDNum !==null? myInfoData.IDNum:'',
                    DOB:myInfoData.DOB !==null? myInfoData.DOB:'',
                    Gender: myInfoData.Gender !== null? getObjInArray(myInfoData.Gender,genders).label:'',
                    Race: myInfoData.Race !== null?  getObjInArray(myInfoData.Race,racecodes).label:'',
                    Nationality: myInfoData.Nationality !==null? getObjInArray(myInfoData.Nationality,nationalitycodes).label:'',
                    CnOfBirth:!myInfoData.CnOfBirth? '': myInfoData.CnOfBirth===null? '': getObjInArray(myInfoData.CnOfBirth,myInfoApiCountries).label,
                    ResStatus:!myInfoData.ResStatus?'': myInfoData.ResStatus === null? '': getObjInArray(myInfoData.ResStatus,residentialcodes).label,
                    Designation: !myInfoData.Designation?'' : myInfoData.Designation === null? '': getObjInArray(myInfoData.Designation,positions).label,
     
                    ResAddType:myInfoData.ResAddType !==null? myInfoData.ResAddType:'',
                    ResBlkNo:myInfoData.ResBlkNo !==null? myInfoData.ResBlkNo:'',
                    ResStreet:myInfoData.ResStreet !==null? myInfoData.ResStreet:'',
                    ResFlrNum:myInfoData.ResFlrNum !==null? myInfoData.ResFlrNum:'',
                    ResUnitNo:myInfoData.ResUnitNo !==null? myInfoData.ResUnitNo:'',
                    ResBldName:myInfoData.ResBldName !==null? myInfoData.ResBldName:'',
                    ResAddLine1:myInfoData.ResAddLine1 !==null? myInfoData.ResAddLine1:'',
                    ResAddLine2:myInfoData.ResAddLine2 !==null? myInfoData.ResAddLine2:'',
                    ResPostalCode:myInfoData.ResPostalCode !==null? myInfoData.ResPostalCode:'',
                    ResCountry:!myInfoData.ResCountry? '': myInfoData.ResCountry === null? '': getObjInArray(myInfoData.ResCountry, myInfoApiCountries).label,
                },
            
                ApplicantSeq:myInfoData.ApplicantSeq,
                Title: myInfoData.Title === null? '':getObjInArray(myInfoData.Title,titles).label,
                Name:myInfoData.Name,
                HanyuName:myInfoData.HanyuName,
    
                titleCbo: data && data !==null? data.Title !==null? getObjInArray(data.Title,titles):'':'',
                marStatusCbo:data && data !==null? data.MarStatus !==null? getObjInArray(data.MarStatus,marStatusArray): getObjInArray(myInfoData.MarStatus,marStatusArray):getObjInArray(myInfoData.MarStatus,marStatusArray),
                counOfDomicileCbo:data && data !==null? data.CouOfDom!==null? getObjInArray(data.CouOfDom,countries):'':'',
    
                em:data && data !==null? data.EmailAdd !==null? data.EmailAdd: myInfoData.EmailAdd !==null? myInfoData.EmailAdd:'':'',
                mno:data && data !==null? data.MobileNo !==null? data.MobileNo: myInfoData.MobileNo !==null? myInfoData.MobileNo:'':'',
         
                MailAddType:config.addTypeLocal,
                MailBlkNo:data && data !==null? data.MailBlkNo !==null? data.MailBlkNo:'':'',
                MailStreet:data && data !==null? data.MailStreet !==null? data.MailStreet:'':'',
                MailFlrNum:data && data !==null? data.MailFlrNum !==null?data.MailFlrNum:'':'',
                MailUnitNo:data && data !==null? data.MailUnitNo !==null? data.MailUnitNo:'':'',
                MailBldName:data && data !==null? data.MailBldName !==null? data.MailBldName:'':'',
                MailPostalCode:data && data !==null? data.MailPostalCode !==null? data.MailPostalCode:'':'',
                MailCountry:appDetailsData.DefCountry.label,

                SG:data && data !==null? data.PersWealthCou.SG === 'true'? true:false:false,
                BN:data && data !==null? data.PersWealthCou.BN === 'true'? true:false:false,
                MY:data && data !==null? data.PersWealthCou.MY === 'true'? true:false:false,
                CN:data && data !==null? data.PersWealthCou.CN === 'true'? true:false:false,
                ID:data && data !==null? data.PersWealthCou.ID === 'true'? true:false:false,
                IN:data && data !==null? data.PersWealthCou.IN === 'true'? true:false:false,
                OTH:data && data !==null? data.PersWealthCou.OTH === 'true'? true:false:false,
                PersWealthOTH:data && data !==null && data.PersWealthCou.OTH === 'true'? data.PersWealthCou.PersWealthOTH !==null? getObjInArray(data.PersWealthCou.PersWealthOTH,countriesriskdashboard):'':'',

                DescActOcc11:occupArray[0]? getObjInArray(occupArray[0],occupations):'',
                DescActOcc21:occupArray[1]? getObjInArray(occupArray[1],occupations):'',
                DescActOcc31:occupArray[2]? getObjInArray(occupArray[2],occupations):'',
            })
        }
        catch(ex) {
         
        }
    }

 
    const setOccListArray = (data) => {
   
        let occArray = [];
        if(data && data !==null){
            if(!Array.isArray(data.DescAccOccList.DescActOcc)) {
                occArray.push(data.DescAccOccList.DescActOcc);
            }
            else {
                occArray = data.DescAccOccList.DescActOcc;
            }
    
        }
 
 
        return occArray;
    }
  
    const onNameCboChange = (e) => {
       setNameCbo(e.value);
    }

    const getObjInArray = (iValue, array) => {
        try {
            const result = array.find( ({ value }) => value === iValue);
        return result;
        }
        catch(e){

        }
    }
 
    const handleRdoPersWealthSGChange= React.useCallback(
        (e) => {
            setSelectedRdoPersWealthSGValue(e.value);
        },
        [selectedRdoPersWealthSGValue]
    );
 
    //checkboxes
    const handleOccupationListChkboxChange = (checkedValue,id) => {
       
    }

    //show / hide ApplicantDetails
    const [showApplicantInfo, setShowApplicantInfo] = useState(false);
    const onShowApplicantInfo = (e) => {
   
        e.preventDefault();
        if(showApplicantInfo){
            setShowApplicantInfo(false)
        }
        else {
            setShowApplicantInfo(true);
        }
    }

    //Form Submit
    const handleSubmit = (eve) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        //alert(JSON.stringify(eve.values))
        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            saveApplicantDetails(formatJsonParams(data));
        }
    }

    let formatJsonParams = function(data) {
        let params = {
            CurrentUser: {
                IDNum: nameCbo.value,
                Seq:null,
                Order:null
            },
            ApplicantDtls : {
                IDNum:nameCbo.value,
                Name: nameCbo.label,  
                ApplicantSeq:1, 
                Title: data.titleCbo.value,
                MarStatus: data.marStatusCbo.value,
                CouOfDom: data.counOfDomicileCbo.value,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno,
                EmailAdd: data.em,

                MailAddrSameAsRes: selectedRdoValue,
                MailAddType:config.addTypeLocal,
                MailPostalCode: data.MailPostalCode,
                MailBlkNo:data.MailBlkNo,
                MailStreet:data.MailStreet,
                MailFlrNum:data.MailFlrNum,
                MailUnitNo:data.MailUnitNo,
                MailBldName:data.MailBldName,
                MailCountry: selectedRdoValue === 'N'? appDetailsData.DefCountry.name:'',

                PersWealthSG: selectedRdoPersWealthSGValue === null? 'Y':selectedRdoPersWealthSGValue,

                PersWealthCou: {
                    SG: selectedRdoPersWealthSGValue === 'Y'? false: data.SG,
                    BN: selectedRdoPersWealthSGValue === 'Y'? false: data.BN,
                    MY: selectedRdoPersWealthSGValue === 'Y'? false: data.MY,
                    CN: selectedRdoPersWealthSGValue === 'Y'? false: data.CN,
                    ID: selectedRdoPersWealthSGValue === 'Y'? false:data.ID,
                    IN: selectedRdoPersWealthSGValue === 'Y'? false:data.IN,
                    OTH: selectedRdoPersWealthSGValue === 'Y'? false: data.OTH,
                    PersWealthOTH: selectedRdoPersWealthSGValue === 'Y'? null: data.OTH? data.PersWealthOTH.value:null,
                },
                DescAccOccList : {
                    DescActOcc:occupationList(data)
                } 
            }
        }
        return params;
    }

    const occupationList = (data) => {
   
        let occList = [];
     
        if(data.DescActOcc11){
            occList.push(data.DescActOcc11.value);
        }
        if(data.DescActOcc21){
            occList.push(data.DescActOcc21.value);
        }
        if(data.DescActOcc31) {
            occList.push(data.DescActOcc31.value);
        }
      
        return occList;
    }

    const createHolders = (data) => {
        let temp = [];
        let myInfoAppDtls = {
            IDNum:data.ApplicantsDtlsMyInfo.IDNum,
            Name:data.ApplicantsDtlsMyInfo.Name,
            Designation:data.ApplicantsDtlsMyInfo.Designation !==null? data.ApplicantsDtlsMyInfo.Designation:'',
            Nationality:data.ApplicantsDtlsMyInfo.Nationality !==null? data.ApplicantsDtlsMyInfo.Nationality:''
        }
        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                temp = data.Holdersdetails;
                setHolders(temp);
            }
          
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null){
                    temp.push(data.Holdersdetails[i]);
                }
            }
            setHolders(temp);
        }
    }

    const validateAPDtlsDOB = () => {
        let isValid = true;
        if(applicantDetails.myInfo.DOB !== null || applicantDetails.myInfo.DOB !== "" || applicantDetails.myInfo.DOB !== undefined) {
            if(dobRegex.test(applicantDetails.myInfo.DOB) === false) {
                isValid = false;
            }
        }
       return isValid
    }

    const validateMyInfoMandatoryFields = () => {
        let isValid = true;
        if(applicantDetails.myInfo.IDNum === null || applicantDetails.myInfo.IDNum === "" || applicantDetails.myInfo.IDNum === undefined) {
       
            isValid = false;
        }
        else if(applicantDetails.myInfo.DOB === null || applicantDetails.myInfo.DOB === "" || applicantDetails.myInfo.DOB === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.Gender === null || applicantDetails.myInfo.Gender === "" || applicantDetails.myInfo.Gender === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.Race === null || applicantDetails.myInfo.Race === "" || applicantDetails.myInfo.Race === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.Nationality === null || applicantDetails.myInfo.Nationality === "" || applicantDetails.myInfo.Nationality === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.CnOfBirth === null || applicantDetails.myInfo.CnOfBirth === "" || applicantDetails.myInfo.CnOfBirth === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.ResStatus === null || applicantDetails.myInfo.ResStatus === "" || applicantDetails.myInfo.ResStatus === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.Designation === null || applicantDetails.myInfo.Designation === "" || applicantDetails.myInfo.Designation === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.ResAddType === null || applicantDetails.myInfo.ResAddType === "" || applicantDetails.myInfo.ResAddType === undefined) {
            isValid = false;
        }
        else if(applicantDetails.myInfo.ResAddType === config.addTypeLocal) {
            if(applicantDetails.myInfo.ResBlkNo === null || applicantDetails.myInfo.ResBlkNo === "" || applicantDetails.myInfo.ResBlkNo === undefined) {
                isValid = false;
            }
            else if(applicantDetails.myInfo.ResStreet === null || applicantDetails.myInfo.ResStreet === "" || applicantDetails.myInfo.ResStreet === undefined) {
                isValid = false;
            }
            else if(applicantDetails.myInfo.ResPostalCode === null || applicantDetails.myInfo.ResPostalCode === "" || applicantDetails.myInfo.ResPostalCode === undefined) {
                isValid = false;
            }
        }
        else if(applicantDetails.myInfo.ResAddType === config.addTypeForeign || applicantDetails.myInfo.ResAddType === config.addTypeLocalUnformat) {
            if(applicantDetails.myInfo.ResAddLine1 === null || applicantDetails.myInfo.ResAddLine1 === "" || applicantDetails.myInfo.ResAddLine1 === undefined) {
                isValid = false;
            }
            else if(applicantDetails.myInfo.ResAddLine2 === null || applicantDetails.myInfo.ResAddLine2 === "" || applicantDetails.myInfo.ResStreet === undefined) {
                isValid = false;
            }
        }
        return isValid;
    }

    const saveApplicantDetails = (params) => {
        if(!validateMyInfoMandatoryFields()){
            //goToErrorPage(config.ErrType.InvalidMyInfoPerson);
            // console.log('missing myinfo data');
            showErrMsg(config.error.MyInfo.MissingData);
            return;
        }
        else if(!validateAPDtlsDOB()){
            // console.log('invalid dob format');
            showErrMsg(config.error.MyInfo.InvalidDOB);
            return;
        }
        
        if(params.ApplicantDtls.PersWealthSG === 'N') {
            if(!helper.validateNoOfCheckedBox(params.ApplicantDtls.PersWealthCou,1,5)){
                showErrMsg(appDetailsData.label.ctrySourceWealth+": "+config.error.SelectChk5);
                return;
            }
        }

        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data
            if(resData.isSucess) {
                goNext();
            }  
            else{
                showErrMsg(config.error.SaveApiFailed);
            }         
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goToErrorPage = (errType) => {
        props.history.push(config.route.InvalidEntity,{errType:errType});
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.BizBankingService);
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const filterData = (filter) => {
        const data = countries.slice();
        return filterBy(data, filter);
    };
    
    const filterChange = (event) => {
        setfCountries(filterData(event.filter));
    };

    const filterCountryRiskData = (filter) => {
        const data = countriesriskdashboard.slice();
        return filterBy(data, filter);
    };
    
    const filterCountryRiskChange = (event) => {
        setfCountriesRisk(filterCountryRiskData(event.filter));
    };

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader />
            <FormContainer>
                <Form onSubmitClick={handleSubmit} 
                    initialValues={applicantDetails}
                    key={JSON.stringify(applicantDetails)}
                    render={(formRenderProps)=>(
                    <FormElement>
                        <fieldset>
                            <Field component={FormTitle} id={appDetailsData.formContainerTitle.T1} name={appDetailsData.formContainerTitle.T1.name} /> 
                            <FieldWrapper>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.nameDDL.lblname}</div>
                                </div>

                                <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                    <div className="box" style={{ marginTop: "5px" }} onClick={onShowApplicantInfo}> 
                                    {showApplicantInfo? 
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Hide Details 
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                                        </span> :
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Show Details  
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                                        </span> }
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                    <ComboBox
                                        id="nameCbo" name="nameCbo"
                                        clearButton={false}
                                        data={appDetailsData.nameDDL.data}
                                        textField="label"
                                        dataItemKey="value"
                                        value={nameCbo}
                                        onChange={onNameCboChange} />
                                    </div>
                                </div>
                            </div>
                            {showApplicantInfo? 
                        
                            <div>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblHanPinName'} leftLabelName={appDetailsData.label.hanPinName} 
                                    id={'hanPinName'} name={applicantDetails.myInfo.HanyuName} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAliasName'} leftLabelName={appDetailsData.label.aliName} 
                                    id={'aliasName'} name={applicantDetails.myInfo.AliasName} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblHanyuAliasName'} leftLabelName={appDetailsData.label.hanPinAliName} 
                                    id={'hanyuAliasName'} name={applicantDetails.myInfo.HanyuAliasName} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblmarName'} leftLabelName={appDetailsData.label.marName} 
                                    id={'marriedName'} name={applicantDetails.myInfo.MarriedName} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblIC'} leftLabelName={appDetailsData.label.ic} 
                                    id={'idNum'} name={applicantDetails.myInfo.IDNum} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblDOB'} leftLabelName={appDetailsData.label.dob} 
                                    id={'dob'} name={applicantDetails.myInfo.DOB} />
                            
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblGender'} leftLabelName={appDetailsData.label.gender} 
                                    id={'Gender'} name={applicantDetails.myInfo.Gender} />
                            
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblRace'} leftLabelName={appDetailsData.label.race} 
                                    id={'Race'} name={applicantDetails.myInfo.Race} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblNationality'} leftLabelName={appDetailsData.label.nationality} 
                                    id={'nationality'} name={applicantDetails.myInfo.Nationality} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCountryOfBirth'} leftLabelName={appDetailsData.label.countryOfBirth} 
                                    id={'countryOfBirth'} name={applicantDetails.myInfo.CnOfBirth} />
                            
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblResiStatus'} leftLabelName={appDetailsData.label.resiStatus} 
                                    id={'resiStatus'} name={applicantDetails.myInfo.ResStatus} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblDesignation'} leftLabelName={appDetailsData.label.designation} 
                                    id={'designation'} name={applicantDetails.myInfo.Designation} />
                            </div>
                         
                            : null}
                         
                            <Field leftLabelId={'lblTitle'} leftLabelName={appDetailsData.titleDDL.lblname}
                                id={'titleCbo'} name={'titleCbo'}
                                component={CusFormComboBox}
                                textField={'label'}
                                data={titles}
                                placeholder={'Please select'}
                                validator={reqDDLValidator} />

                            <Field leftLabelId={'lblMarStatus'} leftLabelName={appDetailsData.marStatusDDL.lblname}
                                id={'marStatusCbo'} name={'marStatusCbo'}
                                component={CusFormComboBox}
                                textField={'label'}
                                data={marStatusArray}
                                dataItemKey="value"
                                value={appDetailsData.marStatusDDL}
                                placeholder={'Please select'}
                                validator={reqDDLValidator} />

                            <Field leftLabelId={'lblCouOfDom'} leftLabelName={appDetailsData.label.countryOfDom}
                                id={'counOfDomicileCbo'} name={'counOfDomicileCbo'}
                                component={CusFormComboBox}
                                textField={'label'}
                                data={fCountries}
                                filterable={true}
                                onFilterChange={filterChange}
                                placeholder={'Please select'}
                                validator={reqDDLValidator} />
                            </FieldWrapper>

                            <div style={{paddingTop: "15px"}}> <hr className="greyPanelLine" /> </div>
                             
                            <Field component={FormSubTitleTooltip} 
                                id={'fstContactDetails'} name={appDetailsData.formSubTitle.ST1}
                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                tooltipTitle={appDetailsData.tooltipText.ST1}/>  

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblCC'} leftLabelName={appDetailsData.label.cc}
                                id={'cc'} name={'+65 Singapore'}/>
                       
                            <Field component={CusFormInput} 
                                leftLabelId={'lblmno'} leftLabelName={appDetailsData.label.mno} 
                                id={'mno'} name={'mno'} placeholder={'Please input'}
                                maxLength={8} validator={mobileNoValidator} />

                            <Field component={CusFormInput} 
                                leftLabelId={'lblem'} leftLabelName={appDetailsData.label.em} 
                                id={'em'} name={'em'} placeholder={'Please input'} 
                                maxLength={60} validator={emailValidator} />

                            <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>

                            <Field component={FormSubTitle} id={'fstST2'} name={appDetailsData.formSubTitle.ST2} />
                            {applicantDetails.myInfo.ResAddType !== config.addTypeLocal?
                                <div>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAddline1'} leftLabelName={appDetailsData.label.addLine1}
                                    id={'addline1'} name={applicantDetails.myInfo.ResAddLine1 !== null?applicantDetails.myInfo.ResAddLine1:''}/>

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAddline1'} leftLabelName={appDetailsData.label.addLine2}
                                    id={'addline1'} name={applicantDetails.myInfo.ResAddLine2 !== null? applicantDetails.myInfo.ResAddLine2:''}/>
                                </div>
                            : <div>
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblBlk'} leftLabelName={appDetailsData.label.blk} 
                                id={'blk'} name={applicantDetails.myInfo.ResBlkNo !==null? applicantDetails.myInfo.ResBlkNo:''} />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblStreet'} leftLabelName={appDetailsData.label.street} 
                                id={'st'} name={applicantDetails.myInfo.ResStreet !==null? applicantDetails.myInfo.ResStreet:''}  />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblLvl'} leftLabelName={appDetailsData.label.level} 
                                id={'lvl'} name={applicantDetails.myInfo.ResFlrNum !==null? applicantDetails.myInfo.ResFlrNum:''} />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblUno'} leftLabelName={appDetailsData.label.unitNo} 
                                id={'uno'} name={applicantDetails.myInfo.ResUnitNo !==null? applicantDetails.myInfo.ResUnitNo:''} />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblbuilding'} leftLabelName={appDetailsData.label.building} 
                                id={'bld'} name={applicantDetails.myInfo.ResBldName !==null? applicantDetails.myInfo.ResBldName:''}  />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblPostalCode'} leftLabelName={appDetailsData.label.postalCode} 
                                id={'ptc'} name={applicantDetails.myInfo.ResPostalCode !==null? applicantDetails.myInfo.ResPostalCode:''}  />

                            <Field component={CusFormLabel} 
                                leftLabelId={'lblcountry'} leftLabelName={appDetailsData.label.country} 
                                id={'ctry'} name={applicantDetails.myInfo.ResCountry}  />

                            </div>}
                       
                            <CusRadioButton name="MailAddrSameAsRes" leftValue='Y' rightValue='N' disabled={false}
                                    label={appDetailsData.label.sameAsRegBizAdd} onChange={(e) => {
                                        setSelectedRdoValue(e.value);
                                        if(formRenderProps.valueGetter("MailPostalCode") !== '') {
                                            formRenderProps.onChange('MailPostalCode', { value: '' });
                                        }
                                        formRenderProps.onChange('MailBlkNo',{value:''});
                                        formRenderProps.onChange('MailStreet',{value:''});
                                        formRenderProps.onChange('MailBldName',{value:''});
                                        formRenderProps.onChange('MailUnitNo',{value:''});
                                        formRenderProps.onChange('MailFlrNum',{value:''})
                                    }} checkedValue={selectedRdoValue} />

                            {selectedRdoValue === 'N'? 
                            <div>
                          
                            <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>

                            <Field component={FormSubTitle} id={'fstContactDetails'} name={appDetailsData.formSubTitle.ST3} />  
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.label.postalCode}</div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                        <div style={{width:'90%', float:'left'}}>
                                            <Field className="k-textbox" name={'MailPostalCode'} 
                                            placeholder={'Please input'} component={FormInput} 
                                            maxLength={6} validator={postalCodeValidator} />
                                        </div>
                                        <div style={{width:'10%', float:'left', textAlign:'center',paddingTop:'5px'}}>
                                            <a className="k-icon k-i-zoom" style={{fontSize:'24px'}} 
                                                onClick={(e)=>{
                                                   e.preventDefault();
                                                 
                                                   let postcode= formRenderProps.valueGetter('MailPostalCode');
                                                    if(postcode === '' || postcode === undefined){
                                                        showErrMsg('Postal Code is required');
                                                        return;
                                                    }
                                                    if(postcode.length > 6 ) {
                                                        showErrMsg('Please enter valid postal code');
                                                        return;
                                                    }
                                                    const params = {
                                                        'postalCode': postcode
                                                    }
                                                    setIsSaving(true);
                                                    service.getAddress(params.postalCode).then( res=> {
                                                        setIsSaving(false);
                                                        // let data=JSON.parse(res.data.d);
                                                        let data= res.data.model[0];
                                             
                                                        formRenderProps.onChange('MailPostalCode', { value: postcode });
                                                        formRenderProps.onChange('MailBlkNo',{value:data.blK_NO});
                                                        formRenderProps.onChange('MailStreet',{value:data.sT_NAME});
                                                        formRenderProps.onChange('MailBldName',{value:data.bldG_NAME});
                                                     })
                                                    .catch(err => {
                                                        setIsSaving(false);
                                                        showErrMsg('Unable to retrieve the address.')
                                                    });
                                                }}></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblMailBlkNo'} leftLabelName={appDetailsData.label.blk} 
                                    id={'MailBlkNo'} name={'MailBlkNo'} placeholder={'Please input'}  maxLength={10} validator={blockValidator} /> 

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblMailStreet'} leftLabelName={appDetailsData.label.street} 
                                    id={'MailStreet'} name={'MailStreet'} placeholder={'Please input'} maxLength={66} validator={streetValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblMailFlrNum'} leftLabelName={appDetailsData.label.level} 
                                    id={'MailFlrNum'} name={'MailFlrNum'} placeholder={'Please input'} maxLength={3} validator={levelValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblMailUnitNo'} leftLabelName={appDetailsData.label.unitNo} 
                                    id={'MailUnitNo'} name={'MailUnitNo'}  placeholder={'Please input'} maxLength={6} validator={unitNoValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputBld'} leftLabelName={appDetailsData.label.building} 
                                    id={'MailBldName'} name={'MailBldName'}  placeholder={'Please input'} maxLength={66} validator={buildingValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblMailCountry'} leftLabelName={appDetailsData.label.country} 
                                    id={'MailCountry'} name={'MailCountry'} disabled={true} />
                                </div>
                             :null}
                          
                        <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>

                        <Field component={FormSubTitle} id={'fstST4'} name={appDetailsData.formSubTitle.ST4} />
                        
                        <ApplicantDtlsOccupation fProps={formRenderProps} seq={1} array={occupList} disabled={false}/>
 
                        <FieldWrapper>
                        <CusRadioButton name="PersWealthSG" leftValue='Y' rightValue='N' disabled={false}
                            label={appDetailsData.label.persWealthSG} onChange={handleRdoPersWealthSGChange} checkedValue={selectedRdoPersWealthSGValue} />
                        </FieldWrapper>     

                       {selectedRdoPersWealthSGValue==='N' && <div>
                       <Field component={FormSubTitle} id={'fstContactDetails'} name={appDetailsData.formSubTitle.ST5} />
                       <div className="row around-xs inputPair elementVisible" >
                            {appDetailsData.PersWealthCouChk.data.map((item, idx) => (
                                <CusFormCheckbox key={idx} id={item.id} lblname={item.lblname} 
                                    onCheckedChange={(checkedValue,id)=>{  }} />))}

                                <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                <div style={{width:'10%',float:'left'}}>
                                    <Field id={appDetailsData.PersWealthCouChk.others.id} name={appDetailsData.PersWealthCouChk.others.id} component={FormCheckbox} disabled={false}
                                        onChange={(e) => {
                                           setPersWealthCouOth(e.value);
                                            if(!e.value){
                                                formRenderProps.onChange('PersWealthOTH', { value: '' });
                                            }
                                        }
                                    } />
                                </div>
                                <div style={{width:'90%',float:'left',paddingTop:'10px'}} >
                                    <Field id={'PersWealthOTH'} 
                                        name={'PersWealthOTH'}
                                        component={FormComboBox}
                                        textField={'label'}
                                        data={fCountriesRisk}
                                        filterable={true}
                                        onFilterChange={filterCountryRiskChange}
                                        placeholder={'Others'} 
                                        validator={!persWealthCouOth? '':reqDDLValidator}
                                        disabled={!persWealthCouOth}/>
                                </div>  
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <div style={{width:'8%',float:'left'}}>
                                    <Field id={appDetailsData.PersWealthCouChk.CN.id} name={appDetailsData.PersWealthCouChk.CN.id} component={FormCheckbox} disabled={false} />       
                                </div>
                                <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                    <label className={'k-checkbox-label'} >{appDetailsData.PersWealthCouChk.CN.lblname}</label>
                                </div>
                            </div>
                        </div>  </div> }
                      
                      <FieldWrapper>
                       <CusProgressBar  bgcolor={item.bgcolor} completed={item.completed} /> 

                       <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"  style={{ paddingBottom: "20px" }}>
                                <button type={"button"} className="btn btn-back" onClick={(e) => { e.preventDefault(); history.push(config.route.TxnActivities);}}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>

                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                                onClose={()=>{ setIsError(false)}} />} */}
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 

                        </fieldset>
                    </FormElement>
                
                )}>
                     
                </Form>
            </FormContainer>
            {isSaving && <Loading />}  
        </div>
  
  )
}

export default ApplicantDetails

